import { render, staticRenderFns } from "./DashboardContributorsList.vue?vue&type=template&id=40c7480e&scoped=true&"
import script from "./DashboardContributorsList.vue?vue&type=script&lang=js&"
export * from "./DashboardContributorsList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContributorsList.vue?vue&type=style&index=0&id=40c7480e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7480e",
  null
  
)

export default component.exports